import { useState } from 'react';
import MeterReadDetailsTable from './MeterReadDetailsTable';

/** minimal types so TS is happy */
type Cell = {
  month_year: string;
  value: number | string | null;
  meter_computed_id?: number;
  readonly?: boolean;
};
type Row = { field: string; label: string; months: Cell[]; editable?: boolean; };

const LAST_ACTUAL_PARENT = 'lastActualReadMonth';
const LAST_ACTUAL_CHILDREN = new Set(['lastActualDelivered', 'lastActualReceived']);
// Row immediately following the Last Actual block — gets a thick top border
// (always visible, collapsed or not) to mark the end of the block, matching
// the divider used below the Prod Stat Net Generation children in the main table.
const SECTION_START_FIELD = 'scadaNet';

const MeterReadDetailsScadaTable = ({
  id,
  rows,
  handleChange,
  saving,
  updating,
  start,
  end,
  shouldUseContractView,
  isEditable,
  noDecimals,
}: {
  id: string | undefined;
  rows: Row[];
  handleChange: any;
  saving: any;
  updating: any;
  start?: Date;
  end?: Date;
  shouldUseContractView?: boolean;
  isEditable?: boolean;
  noDecimals?: boolean;
}) => {
  const [lastActualCollapsed, setLastActualCollapsed] = useState(true);

  const toggleLastActual = () => setLastActualCollapsed((prev) => !prev);

  const processedRows = rows
    .filter((row) => !(LAST_ACTUAL_CHILDREN.has(row.field) && lastActualCollapsed))
    .map((row) => ({
      ...row,
      subRow: LAST_ACTUAL_CHILDREN.has(row.field),
      sectionStart: row.field === SECTION_START_FIELD,
      childrenCollapsed: row.field === LAST_ACTUAL_PARENT ? lastActualCollapsed : undefined,
      onToggleCollapse: row.field === LAST_ACTUAL_PARENT ? toggleLastActual : undefined,
    }));

  return (
    <MeterReadDetailsTable
      id={id}
      rows={processedRows}
      handleChange={handleChange}
      saving={saving}
      updating={updating}
      start={start}
      end={end}
      shouldUseContractView={shouldUseContractView}
      isEditable={isEditable ?? false}
      noDecimals={noDecimals}
      testTable="meter-details"
    />
  );
};

export default MeterReadDetailsScadaTable;
